import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ServidorAlfresco } from '../_models/servidor-alfresco';

@Injectable({
  providedIn: 'root'
})
export class ServidorAlfrescoService {
  private rutServicio = AppSettings.rutServiciosRG + '/api/servidoresAlfresco/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as ServidorAlfresco[] ) );
  }

  listadoEnabled() {
    return this.httpClient.get( this.rutServicio + 'enabled/' ).pipe( map( res => res as ServidorAlfresco[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as ServidorAlfresco ) );
  }

  crear( regCrear: ServidorAlfresco ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ServidorAlfresco ) );
  }

  actualizar( regActualizar: ServidorAlfresco ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
